import React, { forwardRef, useRef, useEffect } from "react";
import { Input, InputRef } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useSignal } from "@preact/signals-react";

import styles from "./PreviewHistoryListItemTitle.module.scss";
import { isEmpty } from "lodash";

export interface PreviewHistoryListItemTitleProps {
  isEditing: boolean;
  value: string;
  handleUpdateTitle: (title: string) => void;
  handleEditing: (isEditing: boolean) => void;
}

export const PreviewHistoryListItemTitle = forwardRef(function (
  props: PreviewHistoryListItemTitleProps,
  ref: React.ForwardedRef<InputRef>
) {
  const { isEditing, value, handleUpdateTitle, handleEditing } = props;

  const title = useSignal<string>(value);
  const titleSavedRef = useRef<string>(title.value);

  function onTitleChange(e: React.ChangeEvent<HTMLInputElement>) {
    title.value = e.target.value;
  }

  function onTitlePressEnter(e: React.KeyboardEvent<HTMLInputElement>) {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.blur();

    // isEditing.value = false;
    handleEditing(false);
  }

  function onTitleBlur(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    /// 数据为空
    if (isEmpty(title.value)) {
      title.value = titleSavedRef.current;
      return;
    }
    /// 数据未修改
    if (title.value === titleSavedRef.current) {
      return;
    }
    /// 保存数据到 previewAppList
    handleUpdateTitle(title.value);
    /// 缓存数据
    titleSavedRef.current = title.value;
  }

  function onTextClick(e: React.MouseEvent<HTMLInputElement | HTMLTextAreaElement | HTMLDivElement>) {
    if (!isEditing) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
  }

  useEffect(() => {
    title.value = value;
  }, [value]);

  return (
    <>
      {isEditing ? (
        <Input
          ref={ref}
          placeholder="Add an app name"
          className={styles.titleInput}
          value={title.value}
          onClick={e => onTextClick(e)}
          onBlur={e => onTitleBlur(e)}
          onChange={e => onTitleChange(e)}
          onPressEnter={e => onTitlePressEnter(e)}
          autoFocus
        />
      ) : (
        <div className={styles.titleWrapper}>
          <div className={styles.title}>{title.value}</div>
          <div onClick={() => handleEditing(true)}>
            <EditOutlined style={{ fontSize: "20px", padding: "10px 20px 10px 5px" }} />
          </div>
        </div>
      )}
    </>
  );
});
